import * as PR from "../prime-modules/index";

export const unlimitedPlanUsageAsterisk = (dataAmountForDisplay, labels, fupdisplay="") => {

    return dataAmountForDisplay === "Unlimited" ? <>
      <PR.Tooltip target=".deviceDetails" position="bottom" baseZIndex={99999}>
      <p className="tooltip-block">{fupdisplay ? fupdisplay : labels.LBL0325}</p>
      </PR.Tooltip>
      <span className="deviceDetails asterisk-unlimited pi pi-info-circle"></span>
    </> : ""
  }